import { AxiosInstance } from 'axios'
import { getCookie } from 'cookies-next'
import { IRequestConfig, IRequestOptions } from '@/shared/services/index'

// Add options interface
interface ServiceOptions {
  axios?: AxiosInstance
}

// Add default options
export const serviceOptionsUser: ServiceOptions = {}

// Instance selector
function axios(configs: IRequestConfig, resolve: (p: any) => void, reject: (p: any) => void): Promise<any> {
  if (serviceOptionsUser.axios) {
    return serviceOptionsUser.axios
      .request(configs)
      .then((res) => {
        resolve(res.data)
      })
      .catch((err) => {
        reject(err)
      })
  } else {
    throw new Error('please inject yourself instance like axios  ')
  }
}

function getConfigs(method: string, contentType: string, url: string, options: any): IRequestConfig {
  const configs: IRequestConfig = { ...options, method, url }
  configs.headers = {
    ...options.headers,
    'Content-Type': contentType,
    Authorization: getCookie('access-token')?'Bearer ' + getCookie('access-token'):''
  }
  return configs
}

interface IR<T> {
  code: number
  msg: string
  data: T
}

export interface IUserPermissionDTO {
  clientId: string
  roles: string[]
  permissions: IResourceAccessDTO[]
}

export interface IResourceAccessDTO {
  id: string
  name: string
  attributes: Map<string, any>
  uris: string[]
  scopes: string[]
}

const basePath = ''

export class AuthControllerService {
  static controllerPath = 'auth'

  /**
   * Get all permission
   */
  static permission(options: IRequestOptions = {}): Promise<IR<IUserPermissionDTO>> {
    return new Promise((resolve, reject) => {
      const url = basePath + this.controllerPath + '/permission'

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options)

      axios(configs, resolve, reject)
    })
  }
}
